import axios from 'axios'
import Auth from '@/services/auth'
import {
  API_BASE,
  apiErrorHandler,
  ApiFilter,
  isDefinedAndNotNull,
  isNotEmpty,
} from '@/services/api'

const CANARY_DASHBOARD_ENDPOINT = `${API_BASE}canary-dashboard/`

const CanaryDashboard = {
  canaryDashboardRequestOptions: {
    headers: {
      'Content-Type': 'text/html',
      ...Auth.getHeaders(),
    }
  },

	async getMetric(metric_name, start_date = null, end_date = null) {
    try {
      const response = await axios.get(CANARY_DASHBOARD_ENDPOINT + metric_name, {
        params: {
          'start_date': start_date,
          'end_date': end_date,
        },
        ...this.canaryDashboardRequestOptions
      })
      const metric_data = response.data

      return metric_data
    } catch (error) {
      console.error(error)
    }

    return null
	}
}

export default CanaryDashboard